import React from 'react';

const ListEmptyIcon: React.FC<{ isNotBg?: boolean }> = ({ isNotBg }) =>
  isNotBg ? (
    <svg width="73" height="73" viewBox="0 0 73 73" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="27.1664"
        y="1.66641"
        width="51"
        height="51"
        rx="13.5"
        transform="rotate(30 27.1664 1.66641)"
        fill="white"
      />
      <rect
        x="27.1664"
        y="1.66641"
        width="51"
        height="51"
        rx="13.5"
        transform="rotate(30 27.1664 1.66641)"
        stroke="#D2D6DB"
      />
      <g filter="url(#filter0_i_34826_93085)">
        <rect x="1.9834" y="14.9277" width="52" height="52" rx="14" fill="white" />
        <rect x="2.4834" y="15.4277" width="51" height="51" rx="13.5" stroke="#D2D6DB" />
        <path
          d="M14.9834 35.9277L14.9834 33.5944C14.9834 30.4648 17.5205 27.9277 20.6501 27.9277L35.3167 27.9277C38.4463 27.9277 40.9834 30.4648 40.9834 33.5944L40.9834 35.9277L14.9834 35.9277Z"
          fill="#00A389"
        />
        <path d="M24.3167 53.9277L31.6501 53.9277L31.6501 37.9277L24.3167 37.9277L24.3167 53.9277Z" fill="#00A389" />
        <g opacity="0.4">
          <path
            d="M40.9834 37.9277L40.9834 48.2611C40.9834 51.3907 38.4463 53.9277 35.3167 53.9277L33.6501 53.9277L33.6501 37.9277L40.9834 37.9277Z"
            fill="#00A389"
          />
          <path
            d="M22.3167 53.9277L20.6501 53.9277C17.5205 53.9277 14.9834 51.3907 14.9834 48.2611L14.9834 37.9277L22.3167 37.9277L22.3167 53.9277Z"
            fill="#00A389"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_i_34826_93085"
          x="1.9834"
          y="12.0277"
          width="52"
          height="54.9"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-4" />
          <feGaussianBlur stdDeviation="1.45" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_34826_93085" />
        </filter>
      </defs>
    </svg>
  ) : (
    <svg width="203" height="173" viewBox="0 0 203 173" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_34826_92446)">
        <line x1="10.5" y1="-4" x2="10.5" y2="178" stroke="#E5E7EB" />
        <line x1="28.5" y1="-4" x2="28.5" y2="178" stroke="#E5E7EB" />
        <line x1="46.5" y1="-4" x2="46.5" y2="178" stroke="#E5E7EB" />
        <line x1="64.5" y1="-4" x2="64.5" y2="178" stroke="#E5E7EB" />
        <line x1="82.5" y1="-4" x2="82.5" y2="178" stroke="#E5E7EB" />
        <line x1="100.5" y1="-4" x2="100.5" y2="178" stroke="#E5E7EB" />
        <line x1="118.5" y1="-4" x2="118.5" y2="178" stroke="#E5E7EB" />
        <line x1="136.5" y1="-4" x2="136.5" y2="178" stroke="#E5E7EB" />
        <line x1="154.5" y1="-4" x2="154.5" y2="178" stroke="#E5E7EB" />
        <line x1="172.5" y1="-4" x2="172.5" y2="178" stroke="#E5E7EB" />
        <line x1="190.5" y1="-4" x2="190.5" y2="178" stroke="#E5E7EB" />
        <line x1="242.688" y1="16.5908" x2="-42.8176" y2="14.5003" stroke="#E5E7EB" />
        <line x1="242.556" y1="34.5898" x2="-42.9494" y2="32.4994" stroke="#E5E7EB" />
        <line x1="242.424" y1="52.5898" x2="-43.081" y2="50.4994" stroke="#E5E7EB" />
        <line x1="242.292" y1="70.5889" x2="-43.2129" y2="68.4984" stroke="#E5E7EB" />
        <line x1="242.16" y1="88.5889" x2="-43.3447" y2="86.4984" stroke="#E5E7EB" />
        <line x1="242.029" y1="106.588" x2="-43.4765" y2="104.497" stroke="#E5E7EB" />
        <line x1="241.897" y1="124.588" x2="-43.6084" y2="122.497" stroke="#E5E7EB" />
        <line x1="241.765" y1="142.587" x2="-43.7402" y2="140.496" stroke="#E5E7EB" />
        <line x1="241.633" y1="160.587" x2="-43.8718" y2="158.496" stroke="#E5E7EB" />
        <rect
          x="104.683"
          y="56.683"
          width="51"
          height="51"
          rx="13.5"
          transform="rotate(30 104.683 56.683)"
          fill="white"
        />
        <rect
          x="104.683"
          y="56.683"
          width="51"
          height="51"
          rx="13.5"
          transform="rotate(30 104.683 56.683)"
          stroke="#D2D6DB"
        />
        <g filter="url(#filter0_i_34826_92446)">
          <rect x="79.5" y="69.9443" width="52" height="52" rx="14" fill="white" />
          <rect x="80" y="70.4443" width="51" height="51" rx="13.5" stroke="#D2D6DB" />
          <path
            d="M92.5 90.9443L92.5 88.611C92.5 85.4814 95.0371 82.9443 98.1667 82.9443L112.833 82.9443C115.963 82.9443 118.5 85.4814 118.5 88.611L118.5 90.9443L92.5 90.9443Z"
            fill="#00A389"
          />
          <path d="M101.833 108.944L109.167 108.944L109.167 92.9443L101.833 92.9443L101.833 108.944Z" fill="#00A389" />
          <g opacity="0.4">
            <path
              d="M118.5 92.9443L118.5 103.278C118.5 106.407 115.963 108.944 112.833 108.944L111.167 108.944L111.167 92.9443L118.5 92.9443Z"
              fill="#00A389"
            />
            <path
              d="M99.8333 108.944L98.1667 108.944C95.0371 108.944 92.5 106.407 92.5 103.278L92.5 92.9443L99.8333 92.9443L99.8333 108.944Z"
              fill="#00A389"
            />
          </g>
        </g>
        <circle cx="96.5" cy="89.5" r="145.5" fill="url(#paint0_radial_34826_92446)" />
      </g>
      <defs>
        <filter
          id="filter0_i_34826_92446"
          x="79.5"
          y="67.0443"
          width="52"
          height="54.9"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-4" />
          <feGaussianBlur stdDeviation="1.45" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_34826_92446" />
        </filter>
        <radialGradient
          id="paint0_radial_34826_92446"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(96.5 89.5) rotate(90) scale(145.5)"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="0.73" stopColor="white" />
        </radialGradient>
        <clipPath id="clip0_34826_92446">
          <rect width="203" height="173" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );

export default ListEmptyIcon;
